import PropTypes from "prop-types";

const SIZE = {
  sm: { w: 28, h: 28, fs: 12, r: 9 },
  md: { w: 38, h: 38, fs: 14, r: 11 },
  lg: { w: 48, h: 48, fs: 16, r: 13 },
};

function initialsOf(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  const first = parts[0] ? parts[0][0] : "";
  const last = parts[1] ? parts[1][0] : "";
  return (first + last).toUpperCase() || "?";
}

export default function Avatar({ name, size, className }) {
  const s = SIZE[size] || SIZE.md;
  const cls = `rec-avatar${className ? ` ${className}` : ""}`;
  return (
    <span
      className={cls}
      style={{ width: s.w, height: s.h, fontSize: s.fs, borderRadius: s.r }}
      title={name || undefined}
    >
      {initialsOf(name)}
    </span>
  );
}

Avatar.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string,
};

Avatar.defaultProps = {
  name: "",
  size: "md",
  className: "",
};
